// Runtime configuration. Populated at app boot by main.jsx from window.__CREW_CONFIG__
// (written by scripts/deploy.sh per stage). Never embed secrets here — only public
// endpoints and IDs.

/**
 * @typedef {Object} CrewConfig
 * @property {string} apiBaseUrl        - API Gateway base URL (no trailing slash), e.g. https://crew-api.getkanjo.com.
 * @property {string} cognitoDomain     - Cognito hosted-UI domain (https://....auth.<region>.amazoncognito.com).
 * @property {string} cognitoClientId   - App client ID (public).
 * @property {string} cognitoRegion     - e.g. "us-west-2".
 * @property {string} cognitoUserPoolId - e.g. "us-west-2_abc123".
 * @property {string} cognitoIssuer     - "https://cognito-idp.<region>.amazonaws.com/<userPoolId>".
 * @property {string} cognitoJwksUrl    - "<issuer>/.well-known/jwks.json".
 * @property {string} stage             - "sandbox" | "prod".
 * @property {string} redirectUri       - OAuth redirect (must match Cognito app client).
 * @property {string} [finixApplicationId] - Finix application id (public; for the card form).
 * @property {string} [finixEnv]        - "sandbox" | "live".
 */

/** @type {CrewConfig | null} */
let cfg = null;

/** @param {CrewConfig} c */
export function configure(c) {
  if (!c || typeof c !== 'object') throw new Error('configure: missing config');
  for (const k of [
    'apiBaseUrl', 'cognitoDomain', 'cognitoClientId', 'cognitoRegion',
    'cognitoUserPoolId', 'cognitoIssuer', 'cognitoJwksUrl', 'stage', 'redirectUri',
  ]) {
    if (typeof c[k] !== 'string' || !c[k]) throw new Error(`configure: missing "${k}"`);
  }
  if (!/^https:\/\//.test(c.apiBaseUrl) && c.stage === 'prod') {
    throw new Error('configure: apiBaseUrl must be HTTPS in prod');
  }
  cfg = Object.freeze({ ...c });
}

/** @returns {CrewConfig} */
export function getConfig() {
  if (!cfg) throw new Error('crew.configure(...) has not been called');
  return cfg;
}
